"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilteredCountRatio = exports.messageWithOrWithoutCount = void 0;
const catalog_messages_1 = require("@tableau/catalog-messages");
function messageWithOrWithoutCount(count, bothMessages) {
    return count != null
        ? bothMessages.withCount({ count: catalog_messages_1.Formatters.formatCount(count) })
        : bothMessages.withoutCount();
}
exports.messageWithOrWithoutCount = messageWithOrWithoutCount;
function getFilteredCountRatio(filteredCount, unfilteredCount) {
    return filteredCount != null && unfilteredCount != null
        ? catalog_messages_1.Messages.XOutOfN({
            countX: catalog_messages_1.Formatters.formatCount(filteredCount),
            countN: catalog_messages_1.Formatters.formatCount(unfilteredCount),
        })
        : null;
}
exports.getFilteredCountRatio = getFilteredCountRatio;
//# sourceMappingURL=FormatUtils.js.map